import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";

const translateDocType: Record<string, "Invoice" | "Attachment"> = {
  FaktObec: "Invoice",
  FaPriloha: "Attachment",
};

const useInvoiceDownloadTitle = () => {
  const tTerms = useTranslation("shared\\terms").t;

  return useCallback(
    (document: DocumentSimplifiedDTO): string => {
      const extension = document.name?.split(".")?.pop()?.toLocaleUpperCase();
      const invoiceTitle = tTerms(translateDocType[document.docHeaderType ?? ""] ?? "Invoice").toLocaleLowerCase();

      return extension
        ? `${extension} ${invoiceTitle}`
        : invoiceTitle;
    },
    [tTerms]
  );
};

export default useInvoiceDownloadTitle;
